import {
  Box,
  Card,
  CardContent,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  OutlinedInput,
  Stack,
  Tab,
  Tabs,
  Typography,
  Button,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import React, { useState, useEffect } from "react";
import SimpleBar from "simplebar-react";
import logo from "../../../assets/svg/fedex.svg";
import logo2 from "../../../assets/svg/ups.svg";
import selected from "../../../assets/svg/selected.svg";
import arrow_check from "../../../assets/svg/arrow_check.svg";
import { useSelector, useDispatch } from "react-redux";
import { createShippingService } from "./shippingService.helper";
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { setShippingServiceState } from '../../../store/shippingServiceSlice';
import { getRoutePartners } from "../../../helper/functions";

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      style={{ maxHeight: "78vh" }}
    >
      {value === index && (
        <Box>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
};

const CarrierCard = ({ location, isSelected, onSelect }) => {
  return (
    <Card
      onClick={() => onSelect(location.id)}
      sx={{
        border: isSelected ? "2px solid green" : "1px solid #e0e0e0",
        borderRadius: "4px",
        cursor: "pointer",
        position: "relative",
        "&:hover": {
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        },
      }}
    >
      <CardContent>
        <img src={location.img} alt={location.name} />
        <Typography sx={{ fontWeight: 700, fontSize: "16px" }}>
          {location.name}
        </Typography>
      </CardContent>
      {isSelected && (
        <Box
          sx={{
            position: "absolute",
            top: 0,
            right: -2,
            color: "green",
          }}
        >
          <img src={selected} alt="select" />
          <img
            src={arrow_check}
            alt="select"
            style={{
              position: "absolute",
              top: 5,
              right: 5,
            }}
          />
        </Box>
      )}
    </Card>
  );
};

export default function ShippingCarrierStep({ onBack, onNext, loading }) {
  const shippingServiceData = useSelector((state) => state.shippingService.shippingServiceData);
  const { carrierPartner } = shippingServiceData;
  const dispatch = useDispatch();
  
  const [selectedCarrier, setSelectedCarrier] = useState(carrierPartner || null);
  const [carrierPartners, setCarrierPartners] = useState([]);

  // Fetch carrier partners from route partner collection
  const fetchCarrierPartners = async () => {
    try {
      const partners = await getRoutePartners([
        { key: 'isCarrierPartner', operator: '==', value: true }
      ]);
      
      // Transform the data to match the expected format with img property
      const transformedPartners = partners.map(partner => ({
        ...partner,
        img: partner.logoUrl || "", // Use partner logo or default logo
        name: partner.name || 'Unknown Carrier'
      }));
      
      setCarrierPartners(transformedPartners);
    } catch (error) {
      console.error("Error fetching carrier partners:", error);
      // Fallback to default carriers if fetch fails
    }
  };

  useEffect(() => {
    fetchCarrierPartners();
  }, []);

  const handleSelectCarrier = (id) => {
    const partner = carrierPartners.find((p) => p.id === id);
    setSelectedCarrier({ id, carrierPartnerName: partner?.name || '' });
  };

  const handleNext = async () => {
    if (selectedCarrier) {
      if (shippingServiceData.id) {
        // Update Firestore and Redux if id exists (add or edit mode)
        try {
          const response = await createShippingService({
            id: shippingServiceData.id,
            carrierPartner: selectedCarrier,
            updatedAt: new Date().toISOString()
          });
          dispatch(setShippingServiceState({
            ...shippingServiceData,
            carrierPartner: response.carrierPartner,
            updatedAt: response.updatedAt
          }));
        } catch (error) {
          console.error("Error saving carrier partner:", error);
        }
      }
      if (onNext) onNext();
    }
  };

  if (loading) {
    return <Box sx={{ p: 4, textAlign: 'center' }}>Loading...</Box>;
  }

  return (
    <SimpleBar
      forceVisible="x"
      autoHide={true}
      style={{
        overflowX: "auto",
        maxHeight: "calc(100vh - 356px)",
        minHeight: "calc(100vh - 356)",
      }}
      className="custom-scrollbar"
    >
      <Box
        sx={{
          width: "50%",
          margin: "0 auto",
          padding: "20px",
          backgroundColor: "white",
        }}
      >
        <Box sx={{ marginTop: 2 }}>
          <Grid container spacing={2}>
            {carrierPartners.map((location) => (
              <Grid item xs={12} sm={12} md={4} key={location.id}>
                <CarrierCard
                  location={location}
                  isSelected={location.id === selectedCarrier?.id}
                  onSelect={handleSelectCarrier}
                />
              </Grid>
            ))}
          </Grid>
        </Box>

        <Box sx={{ display: "flex", justifyContent: "space-between", marginTop: 3 }}>
          <Button
            variant="outlined"
            onClick={onBack}
            disabled={!onBack}
          >
            Back
          </Button>
          <Button
            variant="contained"
            onClick={handleNext}
            disabled={!selectedCarrier}
          >
            Next
          </Button>
        </Box>
      </Box>
    </SimpleBar>
  );
}
